import { CANONICAL_GAME_KEY, REG_EXP } from 'js/components/system/Page/buzz/constants';
import { getCanonicalLinkUrl as getCanonicalLinkUrlCore } from 'js/components/system/Page/helpers';

export * from 'js/components/system/Page/helpers';

// Add custom logic for display canonial tags for a games info popup
export const getCanonicalLinkUrl = (...props) => {
    const isGamesInfoPopup = REG_EXP.test(location.pathname);

    if (isGamesInfoPopup) {
        const game = location.pathname.split(REG_EXP)?.[1];
        const findedGame = Object.values(window.Playtech.Variables.gamesConfiguration || {})
            .find(({ gameCode, seoFriendlyGameName }) => gameCode === game || seoFriendlyGameName === game);
        const customCanonicalUrl = findedGame?.additionalAssets.find(({ name }) => name === CANONICAL_GAME_KEY)?.url;
        const gameUrl = customCanonicalUrl
            ? customCanonicalUrl?.includes(location.origin) ? customCanonicalUrl : location.origin + customCanonicalUrl
            : location.origin + location.pathname;

        return new window.URL(gameUrl, document.baseURI);
    }

    return getCanonicalLinkUrlCore(...props);
};
